import { useId, useRef } from 'react';
import { Paperclip, X } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';

export function MaintenanceFilePicker({
  files,
  onChange,
  disabled,
}: {
  files: File[];
  onChange: (files: File[]) => void;
  disabled?: boolean;
}) {
  const ref = useRef<HTMLInputElement>(null);
  const id = useId();
  return (
    <div className="shrink-0 space-y-2 sm:w-44">
      <input
        ref={ref}
        id={id}
        type="file"
        multiple
        className="hidden"
        aria-label="Selecionar imagens ou vídeos"
        accept="image/jpeg,image/png,image/webp,image/gif,image/heic,image/heif,image/avif,video/mp4,video/quicktime,video/webm,.mov"
        disabled={disabled}
        onChange={(event) => {
          const selected = Array.from(event.target.files ?? []);
          event.target.value = '';
          if (selected.some((file) => file.size > 10 * 1024 * 1024) || files.length + selected.length > 5) {
            toast.error('Selecione até 5 arquivos, com no máximo 10 MB cada.');
            return;
          }
          onChange([...files, ...selected]);
        }}
      />
      <Button
        type="button"
        variant="outline"
        className="w-full"
        disabled={disabled}
        onClick={() => ref.current?.click()}
      >
        <Paperclip /> Anexar mídia
      </Button>
      {files.length > 0 && (
        <ul className="space-y-1">
          {files.map((file, index) => (
            <li
              key={`${index}-${file.name}`}
              className="flex min-w-0 items-center gap-1 rounded-lg border bg-muted/40 px-2 py-1"
            >
              <span className="min-w-0 flex-1 truncate text-xs" title={file.name}>
                {file.name}
              </span>
              <Button
                type="button"
                variant="ghost"
                size="icon-sm"
                disabled={disabled}
                aria-label={`Remover ${file.name}`}
                onClick={() => onChange(files.filter((_, i) => i !== index))}
              >
                <X />
              </Button>
            </li>
          ))}
        </ul>
      )}
      <p className="text-[11px] text-muted-foreground">Fotos e vídeos · até 5 arquivos de 10 MB</p>
    </div>
  );
}

export interface PendingMaintenance {
  description: string;
  files: File[];
  visibility: 'INTERNAL' | 'CLIENT_VISIBLE';
}
